import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import { Logo } from "./Logo";
import { WaitlistForm } from "./WaitlistForm";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "../ui/sheet";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
];

const navClass = ({ isActive }) =>
  `nav-link relative py-1 text-sm tracking-wide transition-colors ${isActive ? "text-navy is-active" : "text-slate-600 hover:text-navy"}`;

export const Header = () => {
  const [waitOpen, setWaitOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/85 backdrop-blur-md">
      <div className="container-x flex h-[72px] items-center justify-between">
        <Link to="/" data-testid="nav-logo-link"><Logo /></Link>
        <nav className="hidden items-center gap-9 lg:flex">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end className={navClass} data-testid={`nav-link-${l.label.toLowerCase()}`}>{l.label}</NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          <button type="button" onClick={() => setWaitOpen(true)} className="btn-outline" data-testid="nav-join-waitlist-button">Join the waitlist</button>
          <Link to="/demo" className="btn-primary" data-testid="nav-request-demo-button">Request a demo</Link>
        </div>
        <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
          <SheetTrigger asChild>
            <button type="button" className="flex h-10 w-10 items-center justify-center border border-slate-300 text-navy lg:hidden" aria-label="Open menu" data-testid="mobile-menu-button">
              <Menu className="h-5 w-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[86vw] max-w-sm bg-white" data-testid="mobile-menu">
            <SheetTitle className="sr-only">Menu</SheetTitle>
            <nav className="mt-10 flex flex-col">
              {LINKS.map((l) => (
                <NavLink key={l.to} to={l.to} end onClick={() => setMenuOpen(false)} className="border-b border-slate-200 py-4 font-display text-3xl text-navy" data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}>{l.label}</NavLink>
              ))}
            </nav>
            <div className="mt-8 flex flex-col gap-3">
              <Link to="/demo" onClick={() => setMenuOpen(false)} className="btn-primary" data-testid="mobile-request-demo-button">Request a demo</Link>
              <button type="button" onClick={() => { setMenuOpen(false); setWaitOpen(true); }} className="btn-outline" data-testid="mobile-join-waitlist-button">Join the waitlist</button>
            </div>
          </SheetContent>
        </Sheet>
      </div>
      <Dialog open={waitOpen} onOpenChange={setWaitOpen}>
        <DialogContent className="w-[94vw] max-w-xl rounded-none border-gold/40 p-6 sm:p-10" data-testid="waitlist-dialog">
          <p className="eyebrow">Early access</p>
          <DialogTitle className="font-display text-3xl font-semibold text-navy sm:text-4xl">Join the waitlist</DialogTitle>
          <DialogDescription className="text-sm leading-relaxed text-slate-600">Be the first to hear launch pricing and when Grace Treasury opens to new churches.</DialogDescription>
          <div className="mt-2"><WaitlistForm id="dialog-waitlist" source="header" /></div>
        </DialogContent>
      </Dialog>
    </header>
  );
};
